// third party
import { QueryOptions } from 'react-query';

// local
import {
  GetSolarFarmByUuidResponse,
  SolarFarmSearchResponse,
} from './solar-farm.schema';
import { getSolarFarmByUuid, getSolarFarmsByName } from './solar-farm.api';

export const SOLAR_FARM_QUERY_KEY_PREIX = 'solar farms';

export const getSolarFarmsByNameQuery = (
  name: string,
): QueryOptions<SolarFarmSearchResponse> => {
  return {
    queryKey: [SOLAR_FARM_QUERY_KEY_PREIX, { name }],
    queryFn: ({ signal }) => getSolarFarmsByName(name, { signal }),
  };
};

export const getSolarFarmByUuidQuery = (
  solar_farm_uuid: string,
): QueryOptions<GetSolarFarmByUuidResponse> => {
  return {
    queryKey: [SOLAR_FARM_QUERY_KEY_PREIX, { solar_farm_uuid }],
    queryFn: () => getSolarFarmByUuid(solar_farm_uuid),
  };
};
